import Search from "components/BaseWidgets/search";
import "./style.scss";

function ContentCard({ children, className = "", onSearch = () => {} }) {
  return (
    <div className={`connect-content-card ${className}`}>
      <Search onSearch={onSearch} className="connect-search" />
      {children}
    </div>
  );
}

export default ContentCard;
